import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ScreenChallengeDetailComponent } from '@kp/challenges/components/screen-challenge-detail/screen-challenge-detail.component';
import { ScreenChallengesComponent } from '@kp/challenges/screen-challenges.component';
import { DetailCardLoaderComponent } from '@kp/shared/components/detail-card-loader/detail-card-loader.component';
import { DetailCardUnloaderComponent } from '@kp/shared/components/detail-card-unloader/detail-card-unloader.component';
import { CardScreen } from '@ktypes/enums';

const routes: Routes = [
  { path: '', component: ScreenChallengesComponent },
  {
    path: ':challengeId',
    component: ScreenChallengeDetailComponent,
    children: [
      {
        path: ':id',
        component: DetailCardLoaderComponent,
        data: { screen: CardScreen.challenges },
      },
      { path: '', component: DetailCardUnloaderComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChallengesRoutingModule {
  static components = [ScreenChallengeDetailComponent, ScreenChallengesComponent];
}
